import {
  React,
  useState,
  useEffect,
  LoaderOverlay,
  withAuth,
  toast,
  connect,
  useDispatch,
  useSelector,
  useNavigate,
  MESSAGES,
} from "./../../common/helper/common-imports.component.js";
import {
  getConditionalRowStyles,
  customExpandableIcon,
  RowsPerPageSelector,
  SearchTable,
  DataTable,
  customDataTableStyles,
} from "./../../common/helper/table-imports.js";
import DistributorsService from "../../../services/distributors-service.js";
import ExpandedComponent from "./row-expand.component.js";
import Confirmation from "../../common/modals/confirmation.component.js";
import Transfer from "./transfer.component.js";
import { distributorsColoumns } from "./distributors-col-component.js";
const DistributortList = () => {
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [dataTableKey, setDataTableKey] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [merchants, setMerchants] = useState([]);
  const [modalShow, setModalShow] = React.useState(false);
  const [modalShowTransfer, setModalShowTransfer] = React.useState(false);
  const [row, setRow] = useState({});
  const selectRows = React.useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);
  const changeStatus = (row) => {
    setModalShow(true);
    setRow({
      merchant_id: row.merchant_detail.merchant_id,
      status: row.merchant_detail.status,
      modalId: "statusChangeDistributor",
    });
  };
  const deleteMerchant = (row) => {
    setModalShow(true);
    setRow({
      merchant_id: row.merchant_detail.merchant_id,
      status: row.merchant_detail.status,
      modalId: "deleteDistributor",
    });
  };

  const deleteConfirmation = () => {
    setLoading(true);
    DistributorsService.deleteDistributorData(row.merchant_id)
      .then((response) => {
        toast.success(MESSAGES.DIST_DELETED);
        getMerchantsList();
        setLoading(false);
        setModalShow(false);
      })
      .catch((error) => {
        const errorMessage = error.response.data;
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        setLoading(false);
      });
  };

  const updateStatus = () => {
    if (row.modalId == "statusChangeMerchant") {
      const suspended = [];
      const resume = [];
      if (row.status.toLowerCase() == "active") {
        suspended.push(row.merchant_id);
        suspendMerchant(suspended);
      } else {
        resume.push(row.merchant_id);
        resumeMerchant(resume);
      }
    } else if (row.modalId == "statusChangeMerchantSuspend") {
      const suspended = [];
      for (var i = 0; i < selectedRows.length > 0; i++) {
        if (selectedRows[i].merchant_detail.status_id.toLowerCase() == "a") {
          suspended.push(selectedRows[i].merchant_detail.merchant_id);
        }
      }
      suspendMerchant(suspended);
    } else if (row.modalId == "statusChangeMerchantResume") {
      const resume = [];
      for (var i = 0; i < selectedRows.length > 0; i++) {
        if (selectedRows[i].merchant_detail.status_id.toLowerCase() == "s") {
          resume.push(selectedRows[i].merchant_detail.merchant_id);
        }
      }
      resumeMerchant(resume);
    } else {
      deleteConfirmation();
    }
  };
  const suspendMerchant = (suspended) => {
    setLoading(true);
    DistributorsService.suspendDistributor(suspended)
      .then((response) => {
        toast.success(MESSAGES.DIST_SUSPENDED);
        getMerchantsList();
        setLoading(false);
        setModalShow(false);
        setSelectedRows([]);
        setDataTableKey((prevKey) => prevKey + 1);
      })
      .catch((error) => {
        const errorMessage = error.response.data;
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        setLoading(false);
      });
  };

  const resumeMerchant = (resume) => {
    setLoading(true);
    DistributorsService.resumeDistributor(resume)
      .then((response) => {
        toast.success(MESSAGES.DIST_RESUME);
        getMerchantsList();
        setLoading(false);
        setModalShow(false);
        setSelectedRows([]);
        setDataTableKey((prevKey) => prevKey + 1);
      })
      .catch((error) => {
        try {
          const errorMessage = error.response.data;
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        } catch (e) {
          toast.error(MESSAGES.SERVER_ERROR);
        }
        setLoading(false);
      });
  };

  const transferAmount = (row) => {
    setModalShowTransfer(true);
    setRow({
      user_id: row.merchant_detail.merchant_id,
      status: row.merchant_detail.status,
      full_name: row.merchant_detail.merchant_name,
      modalId: "transferAmount",
    });
  };
  const confirmTransfer = () => {
    setModalShowTransfer(false);
    getMerchantsList();
  };

  const getMerchantsList = (e) => {
    setLoading(true);
    DistributorsService.getDistributors()
      .then((response) => {
        setMerchants(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching agents:", error);
      });
  };
  useEffect(() => {
    getMerchantsList();
    document.body.style.backgroundColor = "#f0f6fa";

    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);
  const navigate = useNavigate();
  const addNewMerchant = (e) => {
    navigate("/add-distributor");
  };

  const handleRowExpand = (row, data) => {
    const newExpanded = { ...expanded };
    newExpanded[data.merchant_detail.merchant_id] =
      !expanded[data.merchant_detail.merchant_id];
    setExpanded(newExpanded);
  };
  const conditionalRowStyles = [
    {
      when: (data) =>
        data.merchant_detail.merchant_id &&
        !!expanded[data.merchant_detail.merchant_id],
    },
  ];
  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(Number(value));
    setDataTableKey((prevKey) => prevKey + 1);
  };

  const paginationComponentOptions = {
    noRowsPerPage: true,
  };
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const escapeRegExp = (string) => {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
  };
  const flattenValues = (obj) => {
    const values = [];
    const traverse = (item) => {
      if (Array.isArray(item)) {
        item.forEach((subItem) => traverse(subItem));
      } else if (typeof item === "object" && item !== null) {
        Object.entries(item).forEach(([key, value]) => {
          if (!excludedKeys.includes(key)) {
            traverse(value);
          }
        });
      } else {
        values.push(item);
      }
    };
    traverse(obj);
    return values;
  };
  const excludedKeys = ["admin_detail"];
  const filteredData = merchants.filter((row) => {
    const flattenedValues = flattenValues(row);

    // Apply the search on the flattened array of values
    return flattenedValues.some((value) =>
      new RegExp(escapeRegExp(searchTerm), "i").test(value)
    );
  });

  const suspendMultiple = () => {
    setModalShow(true);
    setRow({
      // user_id: row.user_id,
      status: "Suspend",
      modalId: "statusChangeMerchantSuspend",
    });
  };

  const resumeMultiple = () => {
    setModalShow(true);
    setRow({
      // user_id: row.user_id,
      status: "Resume",
      modalId: "statusChangeMerchantResume",
    });
  };
  const [columns, setColumns] = useState(
    distributorsColoumns(expanded, transferAmount, changeStatus, deleteMerchant)
  );
  useEffect(() => {
    if (filteredData?.length) {
      const element = document.getElementsByClassName("sc-bHCmUC");
      const childElement = element[0].children;
      for (let i = 0; i < childElement?.length; i++) {
        const ele = childElement[i].id.split("-")[1];
        if (Number(ele) % 2 === 0){
          childElement[i].classList.add("odd-transaction-table");
        } else {
          childElement[i].classList.add("even-transaction-table");
        }
      }
    }
  }, [filteredData]);

  return (
    <div>
      <LoaderOverlay loading={loading} />

      <div className="container-fluid px-4" style={{ paddingBottom: "30px" }}>
        <h4
          className="updatename updatename1"
          style={{ marginTop: 0, fontWeight: 700, fontSize: "16px" }}
        >
          Distributors
        </h4>
        <div className="container" style={{ backgroundColor: "white" }}>
          <div className="filterBtn">
            <SearchTable
              searchTerm={searchTerm}
              handleSearchChange={handleSearchChange}
            />
            <div className="dt-buttons ui-buttonset">
              <a
                className="dt-button ui-button ui-state-default ui-button-text-only btn btn-success ddfg"
                tabIndex={0}
                aria-controls="examplemgm"
              >
                <span className="ui-button-text" onClick={addNewMerchant}>
                  Add Distributor
                </span>
              </a>
            </div>
          </div>

          <RowsPerPageSelector
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
          <div
            className="tab-content"
            id="nav-tabContent"
            style={{ paddingTop: "15px" }}
          >
            <div
              className="tab-pane fade show active"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
              style={{ position: "relative" }}
            >
              <div className="multi">
                <a
                  className="nav-link dropdown-toggle news fell jhb"
                  id="navbarDropdown"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{
                    opacity: selectedRows.length > 0 ? 1 : "",
                    pointerEvents: selectedRows.length > 0 ? "auto" : "none",
                  }}
                >
                  <i className="fa fa-ellipsis-h" aria-hidden="true" />
                </a>
                <ul
                  className="dropdown-menu dropdown-menu-end mbv"
                  id="nvb"
                  aria-labelledby="navbarDropdown"
                  style={{}}
                >
                  {/* <li>
                              <a className="dropdown-item modal__button" id="open-modal" href="javascript:void(0);" style={{fontSize: '13px'}}>Limits</a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#!" style={{fontSize: '13px'}}>Commission</a>
                            </li> */}
                  <li onClick={suspendMultiple}>
                    <a
                      className="dropdown-item"
                      href="#!"
                      style={{ fontSize: "13px" }}
                    >
                      Suspend
                    </a>
                  </li>
                  <li onClick={resumeMultiple}>
                    <a
                      className="dropdown-item"
                      href="#!"
                      style={{ fontSize: "13px" }}
                    >
                      Activate
                    </a>
                  </li>
                </ul>
                <span className="DataTables_sort_icon css_right ui-icon ui-icon-triangle-1-n" />
              </div>

              <DataTable
                key={dataTableKey}
                className="distributor"
                columns={columns}
                data={filteredData}
                pagination
                // selectableRows
                // expandableRows
                // expandableRowsComponent={ExpandedComponent}
                // onRowExpandToggled={handleRowExpand}
                paginationComponentOptions={paginationComponentOptions}
                conditionalRowStyles={conditionalRowStyles}
                paginationPerPage={rowsPerPage}
                // expandableIcon={customExpandableIcon}
                // expandOnRowClicked = {true}
                customStyles={customDataTableStyles}
                onSelectedRowsChange={selectRows}
              />
            </div>
          </div>
        </div>
      </div>

      <Confirmation
        show={modalShow}
        onHide={() => setModalShow(false)}
        onSave={() => updateStatus(false)}
        status={row.status}
        modalId={row.modalId}
      ></Confirmation>

      {modalShowTransfer && (
        <Transfer
          show={modalShowTransfer}
          rowData={row}
          onSave={() => confirmTransfer(false)}
          onHide={() => setModalShowTransfer(false)}
        />
      )}
    </div>
  );
};
function mapStateToProps(state) {
  const userData = state.authReducer.user;
  return { userData };
}
export default withAuth(connect(mapStateToProps)(DistributortList));
